import { render, staticRenderFns } from "./AsignacionItems.vue?vue&type=template&id=3d0e5e28"
import script from "./AsignacionItems.vue?vue&type=script&lang=js"
export * from "./AsignacionItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports